import styled, { css } from "styled-components";

import Props from "./props";

const Backdraw = styled.div<Props>`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${props => props.theme.colors.black(0.32)};
    transition: opacity 0.3s ease;
    ${({ open }) => css`
        opacity: ${open ? 1 : 0};
    `}
`;

export default Backdraw;
